'use strict';

/**
 * @classname BtnFavorite
 * @classdesc お気に入りボタン
 */
export default class BtnFavorite {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {Object} controller - controller オブジェクト
	 */
	constructor($e, controller) {
		console.log('BtnFavorite.constructor');
		this._$e = $e;

		// プレビューモードであれば、処理は無効
		if(this._$e.closest('html.preview').length > 0) return;

		this._controller = controller;
		this._favorite = null;
		this._jobId = this._$e.attr('data-job-id');
		this._click = false;
		//ログイン中であればtrue
		this._logined = $('header').hasClass('login')

		//このページのURL
		this._currentUrl = window.location.href;

		$e.on('click', (e) => this.onClick(e));
		this._controller.on('favoriteComplete', () => {
			if(this._click) this.onFavoriteComplete();
		});
		this._controller.on('favoriteError', () => {
			this._click = false;
			this._favorite = null;
		});

	};


	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof BtnFavorite
	 * @return {undefined}
	 */
	onClick(e) {
		console.log('BtnFavorite.onClick');
		e.preventDefault();
		if(this._click) return;

		// プレビューモードであれば、処理は無効
		if(this._$e.closest('html.preview').length > 0) return;

		// ログインしていなければ、別ページに飛ぶ
		if(!this._logined) {
			const loginUrl = window.const.URL.LOGIN;
			location.href = `${loginUrl}?return_url=${this._currentUrl}`;
		}else {
			this._click = true;
			if(this._$e.hasClass('on')){
				this._favorite = 'on';
			}else{
				this._favorite = 'off';
			}
			this._controller.favorite(this._jobId);
		}

	};


	/**
	 * お気に入りajax終了
	 *
	 * @memberof BtnFavorite
	 * @return {undefined}
	 */
	onFavoriteComplete() {
		if(!this._click) return;
		console.log('BtnFavorite.onFavoriteComplete');
		if(this._favorite === 'on'){
			this.btnOff();
		}else{
			this.btnOn();
		}
	};


	/**
	 * ボタンをOnにする
	 *
	 * @memberof BtnFavorite
	 * @return {undefined}
	 */
	btnOn() {
		console.log(`BtnFavorite.btnOn/ jobId: ${this._jobId}`);
		this._$e.addClass('on')
		this._favorite = null;
		this._click = false;
	};


	/**
	 * ボタンをOffにする
	 *
	 * @memberof BtnFavorite
	 * @return {undefined}
	 */
	btnOff() {
		console.log(`BtnFavorite.btnOff/ jobId: ${this._jobId}`);
		if(this._$e.closest('.list--favorite')[0]){
			const $card = this._$e.closest('.list-item');
			$card.fadeOut(500);
			setTimeout(() => {
				$card.remove();
			}, 600);
			//再描画する
			location.reload();
		}else{
			this._$e.removeClass('on')
		}
		this._favorite = null;
		this._click = false;
	};
};